import { useMemo } from "react";
import { Link } from "react-router-dom";
import { comics } from "@/mocks/comics";
import { categories } from "@/mocks/categories";

const categoryName = (slug: string) => categories.find((item) => item.slug === slug)?.name ?? slug;

export default function HotRanking() {
  const ranking = useMemo(() => [...comics].sort((a, b) => b.downloads - a.downloads).slice(0, 8), []);

  return (
    <section className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
      <div className="flex items-center justify-between gap-3">
        <h2 className="flex items-center gap-2 font-heading text-lg font-extrabold text-foreground-950">
          <i className="ri-bar-chart-box-line text-accent-600" />
          热门下载榜
        </h2>
        <Link to="/search" className="whitespace-nowrap text-xs font-medium text-primary-600 transition-colors hover:text-accent-600">
          更多
        </Link>
      </div>

      <ul className="mt-4 flex flex-col divide-y divide-background-200">
        {ranking.map((comic, rankIndex) => (
          <li key={comic.id}>
            <Link to={`/detail/${comic.id}`} className="group flex items-center gap-3 py-3">
              <span
                className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-bold ${
                  rankIndex < 3 ? "bg-accent-500 text-background-50" : "bg-background-200 text-foreground-600"
                }`}
              >
                {rankIndex + 1}
              </span>
              <span className="relative block h-14 w-11 shrink-0 overflow-hidden rounded-md bg-background-100">
                <img
                  src={comic.cover}
                  alt={`${comic.title} 封面`}
                  className="h-full w-full object-cover object-top"
                />
              </span>
              <span className="min-w-0 flex-1">
                <span className="block truncate text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
                  {comic.title}
                </span>
                <span className="mt-0.5 block truncate text-xs text-foreground-500">
                  {categoryName(comic.categories[0])} · {comic.author}
                </span>
              </span>
              <span className="flex shrink-0 items-center gap-1 text-xs font-medium text-accent-600">
                <i className="ri-download-cloud-2-line" />
                {(comic.downloads / 10000).toFixed(1)}万
              </span>
            </Link>
          </li>
        ))}
      </ul>

      <Link
        to="/category/rexue"
        className="mt-4 flex cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
      >
        <i className="ri-compass-3-line" />
        按分类逛逛
      </Link>
    </section>
  );
}